<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" @change="onSjsqChange" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect
              />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
<!--      <a-button type="primary" icon="plus" @click="addHandle">新建</a-button>-->
      <!--<a-button type="primary" icon="plus" @click="applyVisible=true" >申请办赛</a-button>-->
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.name }}
            <br/><span style="color: #999">赛事名称 {{ record.saiqu_name}}</span>
            <br/>
<!--            举办时间 {{ record.saidate|timeFormat }}-->
          </div>
      </span>

      <span slot="reward_price" slot-scope="text,record">
        奖励:{{record.rewards_price + record.rewards_extra_price}}
<!--            服务费:{{record.memberoneprice}} | 成本:{{record.undertake_cost}}<br/>-->
<!--            总人数:{{record.reward_total.member_count_total}}-->
<!--            <br/><span :style="'color:'+(record.cash_id_seller ==0?'#52c41a':'#999')+';text-decoration:'+(record.cash_id_seller<0?'line-through':'')" v-if="record.reward_total">省级:{{record.reward_total.province_price_total}}</span>-->
<!--            <br/><span :style="'color:'+(record.cash_id_team ==0?'#52c41a':'#999')+';text-decoration:'+(record.cash_id_team<0?'line-through':'')" v-if="record.reward_total">市级:{{record.reward_total.city_price_total}}</span>-->
<!--            <br/><span style="color: #999" v-if="record.reward_total">承办方:{{record.reward_total.other_price_total - record.undertake_cost}}</span>-->
      </span>

      <span slot="action" slot-scope="text,record">
        <template>
          <a-popconfirm title="确定申请结算吗" v-if="record.status == 1" @confirm="onReward(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">申请结算</a>
          </a-popconfirm>
          <div v-if="record.status == 2">待审核</div>
          <div v-if="record.status == 3">审核成功</div>
          <div v-if="record.status == 4">审核失败</div>

          <a-divider type="vertical" />

          <a @click="handleEdit(record)">发票信息</a>
<!--          <div>已申请</div>-->
<!--          <a-divider type="vertical"/>-->
          <!--<a @click="handleDate(record)">日程安排</a>-->
          <!--<a-divider type="vertical" />-->
<!--          <a-dropdown>-->
<!--            <a class="ant-dropdown-link">-->
<!--              更多 <a-icon type="down"/>-->
<!--            </a>-->
<!--            <a-menu slot="overlay">-->
<!--              <a-menu-item>-->
<!--          <a @click="handleDocument(record)">相关文件</a>-->
<!--              </a-menu-item>-->

<!--              <a-menu-item>-->
<!--          <a @click="handleRoomType(record)">房型配置</a>-->
<!--              </a-menu-item>-->
<!--              <a-menu-item>-->
<!--          <a @click="handleStation(record)">车站机场配置</a>-->
<!--              </a-menu-item>-->
<!--              <a-menu-item>-->
<!--          <a @click="handleZhixingguan(record)">执行官</a>-->
<!--              </a-menu-item>-->
<!--            </a-menu>-->
<!--          </a-dropdown>-->

        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form"> 

          <a-row :gutter="48"> 
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="电子发票"
                  hasFeedback
              >
                <pic-uploader
                    :numberLimit="1"
                    :file-list="formData.fapiao"
                />
              </a-form-item>
            </a-col>
          </a-row>
           

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="相关文件操作"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="documentVisible"
        @ok="documentVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table :columns="documentColumns" :dataSource="documentList" :pagination="false" rowKey="id"
                   :scroll="{ y: 300 }" bordered>
            <span slot="name" slot-scope="name,record">
<!--              <img :src="record.face" style="width: 40px; vertical-align: middle;" /> -->
              {{ record.title }}
            </span>
            <span slot="typename" slot-scope="name,record">
              <em v-if="record.type==1">
                  通知文件
              </em>
              <em v-else-if="record.type==2">
                  日程表
              </em>
              <em v-else-if="record.type==3">
                  食宿安排
              </em>
            </span>
            <template slot="action" slot-scope="text,record,index">
              <!--              <a-divider type="vertical" />-->
              <a-popconfirm title="确定删除该文章吗" @confirm="deleteFile(record,index)" okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <content-picker style="width: 500px; margin-right: 10px;" :formData="fileFormData" field="content_id"/>
              <a-select style="width: 200px; margin-right: 10px;" v-model="fileFormData.type" placeholder="类型">
                <a-select-option value="1">通知文件</a-select-option>
                <a-select-option value="2">日程表</a-select-option>
                <a-select-option value="3">食宿安排</a-select-option>
              </a-select>
              <a-button icon="plus" @click="addFile">新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="房型设置"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="roomTypeVisible"
        @ok="roomTypeVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
            :columns="roomTypeColumns"
            :dataSource="roomTypeList"
            :pagination="false"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
        >

        <span slot="show" slot-scope="text,record">
          <a-tag v-if="record.show==1" color="green">显示</a-tag>
          <a-tag v-else>隐藏</a-tag>
        </span>
          <template slot="action" slot-scope="text,record,index">
            <a href="javascript:;" @click="onEditRoomType(record)">编辑</a>
            <a-divider type="vertical"/>
            <a-popconfirm
                title="确定删除吗"
                @confirm="deleteRoomType(record,index)"
                okText="确定"
                cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
          <template slot="footer" slot-scope="currentPageData">
            <a-button icon="plus" @click="onAddRoomType">新增</a-button>
          </template>
        </a-table>
      </a-spin>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="食宿配置"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="roomTypeFormVisible"
        @ok="handleRoomTypeOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
              >
                <a-input v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入套餐名称' }]}
            ]"
                         placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="限住人数"
                  hasFeedback
              >
                <a-input v-decorator="[
              'limit',
              {rules: [{ required: true, message: '请输入限住人数' } ]}
            ]"
                         placeholder="请输入限住人数"/>
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单价"
                  extra="按照房间总价格填写"
                  hasFeedback
              >
                <a-input v-decorator="[
              'price',
              {rules: [{ required: true, message: '请输入单价' }]}
            ]"
                         placeholder="请输入单价"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否显示"
                  hasFeedback
              >
                <r-switch :formData="roomTypeFormData" field="show" :checkedValue="1" :unCheckedValue="2"
                          checkedChildren="是" unCheckedChildren="否"/>
              </a-form-item>
            </a-col>

          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleRoomTypeCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleRoomTypeOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="车站机场设置"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="stationVisible"
        @ok="stationVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
            :columns="stationColumns"
            :dataSource="stationList"
            :pagination="false"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
        >

          <template slot="action" slot-scope="text,record,index">
            <a href="javascript:;" @click="onEditStation(record)">编辑</a>
            <a-divider type="vertical"/>
            <a-popconfirm
                title="确定删除吗"
                @confirm="deleteStation(record,index)"
                okText="确定"
                cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
          <template slot="footer" slot-scope="currentPageData">
            <a-button icon="plus" @click="onAddStation">新增</a-button>
          </template>
        </a-table>
      </a-spin>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="车站机场配置"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="stationFormVisible"
        @ok="handleStationOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form5">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
              >
                <a-input v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入车站机场名称' }]}
            ]"
                         placeholder="请输入车站机场名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="地址"
                  hasFeedback
              >
                <a-input v-decorator="[
              'address',
              {rules: [{ required: true, message: '请输入地址' } ]}
            ]"
                         placeholder="请输入地址"/>
              </a-form-item>
            </a-col>

          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleStationCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleStationOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="执行官设置"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="zhixingguanVisible"
        @ok="zhixingguanVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
            :columns="zhixingguanColumns"
            :dataSource="zhixingguanList"
            :pagination="false"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
        >

          <template slot="action" slot-scope="text,record,index">
            <a href="javascript:;" @click="onEditZhixingguan(record)">编辑</a>
            <a-divider type="vertical"/>
            <a-popconfirm
                title="确定删除吗"
                @confirm="deleteZhixingguan(record,index)"
                okText="确定"
                cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
          <template slot="footer" slot-scope="currentPageData">
            <a-button icon="plus" @click="onAddZhixingguan">新增</a-button>
          </template>
        </a-table>
      </a-spin>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="执行官配置"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="zhixingguanFormVisible"
        @ok="handleZhixingguanOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form6">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                         placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证号' } ]}
            ]"
                         placeholder="请输入身份证号"/>
              </a-form-item>
            </a-col>

          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleZhixingguanCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleZhixingguanOk">保存</a-button>
      </template>
    </a-modal>


  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import RSwitch from '@/components/RSwitch/'
import ContentPicker from '@/components/ContentPicker/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

import {
  getSaiquCashList,
  getCashDetail,
  subjectOptions,
  sjsqOptions,
  cashEdit, 
  onSaiReward,
  getSaijiList,
  getSubjectTypeOptions,
  addSaiFile,
  deleteSaiFile,
  getSaiFileList,
  getRoomTypeList,
  roomTypeDelete,
  getRoomTypeDetail,
  editRoomType,
  addRoomType,
  getHotelList,
  hotelDelete,
  getHotelDetail,
  editHotel,
  addHotel,
  getBusList,
  busDelete,
  getBusDetail,
  editBus,
  addBus,
  getStationList,
  stationDelete,
  getStationDetail,
  editStation,
  addStation ,
  getZhixingguanList,
  zhixingguanDelete,
  getZhixingguanDetail,
  editZhixingguan,
  addZhixingguan
} from '@/api/sai'

export default {
  name: 'SaiquRewardList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    RSwitch,
    EditableCell, ContentPicker
  },
  data() {
    return {
      areaOptions,
      sjsqOptions:[],
      visible: false,
      applyVisible: false,
      documentVisible: false,
      saveLoading: false,
      subjectTypeOptions: [],
      mainUnitShow: false,
      holdUnitShow: false,
      helpUnitShow: false,
      unitName: '',
      holdUnitName: '',
      helpUnitName: '',
      formData: {
        id: 0, 
        fapiao: [], 
      },
      saijiOptions: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      form4: this.$form.createForm(this),
      form5: this.$form.createForm(this),
      form6: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '名称',
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '奖励信息',
          dataIndex: 'reward_price',
          scopedSlots: {customRender: 'reward_price'},
        },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   scopedSlots: {customRender: 'status'},
        // },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;


        this.queryParam = Object.assign(this.queryParam, parameter);
        return getSaiquCashList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      },
      fileFormData: {
        saiqu: undefined,
        content_id: undefined,
      },
      //人员管理表头
      documentColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '标题',
          dataIndex: 'title',
          scopedSlots: {customRender: 'name'},
        },/*
                 {
                 title: '角色',
                 width:'100px',
                 dataIndex: 'role_type',
                 },*/

        {
          title: '类型',
          width: '100px',
          dataIndex: 'type',
          scopedSlots: {customRender: 'typename'},
          filters: [
            {
              text: '通知文件',
              value: '1'
            },
            {
              text: '日程表',
              value: '2'
            },
            {
              text: '食宿安排',
              value: '3'
            },
          ],
          filterMultiple: false,
          onFilter: (value, record) => record.type == value,
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: {customRender: 'action'},
        }
      ],
      documentList: [],
      documentKeywords: '',

      roomTypeQuery: {
        saiqu: 0,
      },
      roomTypeVisible: false,
      roomTypeFormVisible: false,
      roomTypeList: [],
      roomTypeFormData: {
        id: 0,
        name: '',
        limit: '',
        price: '',
        show: 1,
      },

      //表头
      roomTypeColumns: [
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '价格',
          width: '150px',
          dataIndex: 'price',
        },
        {
          title: '限住人数',
          width: '150px',
          dataIndex: 'limit',
        },
        {
          title: '显示',
          dataIndex: 'show',
          width: '150px',
          scopedSlots: {customRender: 'show'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: {customRender: 'action'},
        },
      ],


      //酒店
      hotelQuery: {
        saiqu: 0,
      },
      hotelVisible: false,
      hotelFormVisible: false,
      hotelList: [],
      hotelFormData: {
        id: 0,
        level: '',
      },

      //表头
      hotelColumns: [
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '地址',
          width: '150px',
          dataIndex: 'address',
        },
        {
          title: '联系',
          width: '150px',
          dataIndex: 'lianxi',
          scopedSlots: {customRender: 'lianxi'},
        },
        {
          title: '等级',
          dataIndex: 'level',
          width: '150px',
          scopedSlots: {customRender: 'level'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: {customRender: 'action'},
        },
      ],


      //交通
      busQuery: {
        saiqu: 0,
      },
      busVisible: false,
      busFormVisible: false,
      busList: [],
      busFormData: {
        id: 0,
        level: '',
      },

      //表头
      busColumns: [
        {
          title: '车型',
          dataIndex: 'name',
        },
        {
          title: '座位数',
          width: '150px',
          dataIndex: 'limit',
        },
        {
          title: '价格',
          width: '150px',
          dataIndex: 'price',
        },
        {
          title: '数量',
          dataIndex: 'number',
          width: '150px',
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: {customRender: 'action'},
        },
      ],

      //车站
      stationQuery: {
        saiqu: 0,
      },
      stationVisible: false,
      stationFormVisible: false,
      stationList: [],
      stationFormData: {
        id: 0,
        level: '',
      },

      //表头
      stationColumns: [
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '地址',
          width: '250px',
          dataIndex: 'address',
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: {customRender: 'action'},
        },
      ],


      //执行官

      zhixingguanQuery: {
        saiqu: 0,
      },
      zhixingguanVisible: false,
      zhixingguanFormVisible: false,
      zhixingguanList: [],
      zhixingguanFormData: {
        id: 0,
        level: '',
      },

      //表头
      zhixingguanColumns: [
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '身份证',
          width: '250px',
          dataIndex: 'num',
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: {customRender: 'action'},
        },
      ],
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
    // that.getSaijiOptions();
    that.getSjsqOptions();
    that.getSubjectTypeOptions();
  },
  methods: {
    moment,
    getSjsqOptions(){
      let that = this;
      sjsqOptions({}).then(res =>{
        that.sjsqOptions = res.data;
      });
    },
    addHandle() {
      this.formData = {
        id: 0,
        status: 1,
        photo_service: 2,
        show_result: 2,
        show_cert: 2,
        show_jlcert: 2,
        can_youxiu: 2,
        is_online: 2,
        forcehotel: 2,
        localhotel: 1,
        can_kaipiao: 2,
        prize_mod: 'rank',
        need_shenhe: 1,
        need_video: 1,
        type: 1,
        price_mod:1,
        saidate_moment: [],
        saidate: [],
        time_range_moment: [],
        time_range: [],
        erweiimg: [],
        erweiimg2: [],
        erweiimg3: [],
        areas: [],
        pic: [],
        pics: [],
        pic1: [],
        pic2: [],
        pic3: [],
        pic4: [],
        pic5: [],
        pic6: [],
        pic7: [],
        pic8: [],
        score_pdf_url: [],
        zhixuce_pdf_url: [],
        main_unit: [],
        hold_unit: [],
        help_unit: [],
      },
          this.form.resetFields();
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    getSaijiOptions() {
      let that = this;
      getSaijiList().then(res => {
        that.saijiOptions = res.data.list
      })
    },
    getSubjectTypeOptions() {
      let that = this;
      getSubjectTypeOptions().then(res => {
        that.subjectTypeOptions = res.data
      })
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDate(record) {
      const {href} = this.$router.resolve({name: 'SaiDateDetail', query: {id: record.id}});
      window.open(href, '_blank');
    },
    handleEdit(record) {
      let self = this
      this.visible = true
      getCashDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.formData.id = record.id;
          console.log('handleEdit')
          if (res.data.area) {
            res.data.areas = [res.data.area.substring(0, 2) + '0000', res.data.area.substring(0, 4) + '00', res.data.area];
          } else {
            res.data.areas = [];
          }
          res.data.saidate_moment = [moment(res.data.saidate * 1000), moment(res.data.saidate_end * 1000)]; //moment(res.data.saidate*1000);
          res.data.time_range_moment = [moment(res.data.stime * 1000), moment(res.data.etime * 1000)];
          self.formData = {...res.data};
        }, 200)
      })
      // console.log(this.mdl)
    },

    onReward(record) {
      let self = this
      onSaiReward({id: record.id}).then(res => {
        self.$message.success('结算申请成功');
        self.$refs.table.refresh(false)
      }).catch(err => {
        self.$message.error(err.data.msg);
        self.saveLoading = false;
      })
      // console.log(this.mdl)
    },

    onSjsqChange(value){
      let that = this;
      if(value.length ==2){
        console.log(value);
        that.getSubjectOptions(value[1]);
      }
    },

    getSubjectOptions(saiqu){
      let that = this;
      console.log(saiqu);
      subjectOptions({
        saiqu:saiqu
      }).then(res =>{
        that.subjectOptions = res.data;
      });
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault() 
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true; 
            cashEdit({
              id: self.formData.id, 
              fapiao: self.formData.fapiao, 
            }).then(res => {
              self.$message.success('保存成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            }) 
        }
      })
    },

    // 操作单位
    onUnitSet(type) {
      switch (type) {
        case 1:
          this.mainUnitShow = true
          break;

        case 2:
          this.holdUnitShow = true
          break;
        case 3:
          this.helpUnitShow = true
          break;
      }
    },

    // 新增单位
    onUnitAdd(type) {
      const that = this

      console.log(that.formData.main_unit)
      switch (type) {
        case 1:
          that.formData.main_unit.push(that.unitName)
          that.mainUnitShow = false
          that.unitName = ''
          break;

        case 2:
          that.formData.hold_unit.push(that.holdUnitName)
          that.holdUnitShow = false
          that.holdUnitName = ''
          break;

        case 3:
          that.formData.help_unit.push(that.helpUnitName)
          that.helpUnitShow = false
          that.helpUnitName = ''
          break;
      }

    },

    // 删除单位
    onUnitDelete(type, index) {
      const that = this
      switch (type) {
        case 1:
          this.formData.main_unit.splice(index, 1)
          this.mainUnitShow = false
          break;

        case 2:
          this.formData.hold_unit.splice(index, 1)
          this.holdUnitShow = true
          break;

        case 3:
          this.formData.help_unit.splice(index, 1)
          this.helpUnitShow = true
          break;
      }

      that.unitName = ''
    },

    handleDocument(record) {
      let self = this
      self.fileFormData.saiqu = record.id;
      self.getDocumentList();

      this.documentVisible = true
    },

    getDocumentList() {
      let self = this
      getSaiFileList({saiqu: self.fileFormData.saiqu}).then(res => {
        self.documentList = res.data
      })
    },

    addFile() {
      let self = this;
      if (!self.fileFormData.content_id) {
        self.$message.error('请选择文章');
        return;
      }
      if (!self.fileFormData.type) {
        self.$message.error('请选择类型');
        return;
      }
      addSaiFile(self.fileFormData).then(res => {
        self.getDocumentList();

        self.fileFormData.content_id = undefined;
        // self.fileFormData.saiqu = undefined;

        self.$message.success('新增成功')
      }).catch(err => {
        self.$message.error(err.data.msg);
      })
    },
    deleteFile(record, index) {
      let self = this;
      deleteSaiFile({
        saiqu: self.fileFormData.saiqu,
        content_id: record.id,
        content_id: record.id,
      }).then(res => {
        self.$message.success('删除成功')
        self.documentList.splice(index, 1);
      }).catch(err => {
        self.$message.error(err.data.msg);
      })
    },


    onAddRoomType() {
      this.roomTypeFormData = {
        id: 0,
        name: '',
        limit: '',
        price: '',
        show: 1,
      },
          this.form2.resetFields();
      this.roomTypeFormVisible = true
    },

    handleRoomTypeCancel() {
      this.roomTypeFormVisible = false
    },
    onEditRoomType(record) {
      let self = this
      this.roomTypeFormVisible = true
      getRoomTypeDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form2.setFieldsValue({...res.data})
          self.roomTypeFormData.id = record.id;
          self.roomTypeFormData = {...res.data};
        }, 200)
      })
    },
    deleteRoomType(record) {
      let self = this;
      roomTypeDelete({id: record.id}).then(res => {
        self.fetchRoomTypeList();
      })
    },

    fetchRoomTypeList() {
      let self = this
      getRoomTypeList(self.roomTypeQuery).then(res => {
        self.roomTypeList = res.data
      })
    },


    handleRoomType(record) {
      let self = this
      self.fetchRoomTypeList()
      self.roomTypeQuery.saiqu = record.id;
      self.roomTypeVisible = true
    },


    // 增改 处理
    handleRoomTypeOk(e) {
      let self = this;
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.roomTypeFormData)
          self.saveLoading = true;
          if (self.roomTypeFormData.id > 0) {
            editRoomType({
              id: self.roomTypeFormData.id,
              name: values.name,
              price: values.price,
              limit: values.limit,
              show: self.roomTypeFormData.show,
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchRoomTypeList();

              self.roomTypeFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          } else {
            addRoomType({
              name: values.name,
              price: values.price,
              note: values.note,
              saiqu: self.roomTypeQuery.saiqu,
              limit: values.limit,
              show: self.roomTypeFormData.show,
            }).then(res => {
              self.$message.success('新增成功')
              self.fetchRoomTypeList();


              self.roomTypeFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },


    //酒店

    onAddHotel() {
      this.hotelFormData = {
        id: 0,
        name: '',
        limit: '',
        price: '',
        show: 1,
      },
          this.form2.resetFields();
      this.hotelFormVisible = true
    },

    handleHotelCancel() {
      this.hotelFormVisible = false
    },
    onEditHotel(record) {
      let self = this
      this.hotelFormVisible = true
      getHotelDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form3.setFieldsValue({...res.data})
          self.hotelFormData.id = record.id;
          self.hotelFormData = {...res.data};
        }, 200)
      })
    },
    deleteHotel(record) {
      let self = this;
      hotelDelete({id: record.id}).then(res => {
        self.fetchHotelList();
      })
    },

    fetchHotelList() {
      let self = this
      getHotelList(self.hotelQuery).then(res => {
        self.hotelList = res.data
      })
    },


    handleHotel(record) {
      let self = this
      self.fetchHotelList()
      self.hotelQuery.saiqu = record.id;
      self.hotelVisible = true
    },


    // 增改 处理
    handleHotelOk(e) {
      let self = this;

      if (!self.hotelFormData.level) {
        self.$message.error('请选择等级');
        return;
      }

      e.preventDefault()
      this.form3.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.hotelFormData)
          self.saveLoading = true;
          if (self.hotelFormData.id > 0) {
            editHotel({
              id: self.hotelFormData.id,
              name: values.name,
              address: values.address,
              contact_name: values.contact_name,
              contact_phone: values.contact_phone,
              level: self.hotelFormData.level,
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchHotelList();

              self.hotelFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          } else {
            addHotel({
              saiqu: self.hotelQuery.saiqu,
              name: values.name,
              address: values.address,
              contact_name: values.contact_name,
              contact_phone: values.contact_phone,
              level: self.hotelFormData.level,
            }).then(res => {
              self.$message.success('新增成功')
              self.fetchHotelList();

              self.hotelFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },

    //交通

    onAddBus() {
      this.busFormData = {
        id: 0,
        name: '',
        limit: '',
        price: '',
        show: 1,
      },
          this.form2.resetFields();
      this.busFormVisible = true
    },

    handleBusCancel() {
      this.busFormVisible = false
    },
    onEditBus(record) {
      let self = this
      this.busFormVisible = true
      getBusDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form3.setFieldsValue({...res.data})
          self.busFormData.id = record.id;
          self.busFormData = {...res.data};
        }, 200)
      })
    },
    deleteBus(record) {
      let self = this;
      busDelete({id: record.id}).then(res => {
        self.fetchBusList();
      })
    },

    fetchBusList() {
      let self = this
      getBusList(self.busQuery).then(res => {
        self.busList = res.data
      })
    },


    handleBus(record) {
      let self = this
      self.fetchBusList()
      self.busQuery.saiqu = record.id;
      self.busVisible = true
    },


    // 增改 处理
    handleBusOk(e) {
      let self = this;

      e.preventDefault()
      this.form4.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.busFormData)
          self.saveLoading = true;
          if (self.busFormData.id > 0) {
            editBus({
              id: self.busFormData.id,
              name: values.name,
              price: values.price,
              limit: values.limit,
              number: values.number,
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchBusList();

              self.busFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          } else {
            addBus({
              saiqu: self.busQuery.saiqu,
              name: values.name,
              price: values.price,
              limit: values.limit,
              number: values.number,
            }).then(res => {
              self.$message.success('新增成功')
              self.fetchBusList();

              self.busFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },


    //车站

    onAddStation() {
      this.stationFormData = {
        id: 0,
        name: '',
        limit: '',
        price: '',
        show: 1,
      },
          this.form2.resetFields();
      this.stationFormVisible = true
    },

    handleStationCancel() {
      this.stationFormVisible = false
    },
    onEditStation(record) {
      let self = this
      this.stationFormVisible = true
      getStationDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form5.setFieldsValue({...res.data})
          self.stationFormData.id = record.id;
          self.stationFormData = {...res.data};
        }, 200)
      })
    },
    deleteStation(record) {
      let self = this;
      stationDelete({id: record.id}).then(res => {
        self.fetchStationList();
      })
    },

    fetchStationList() {
      let self = this
      getStationList(self.stationQuery).then(res => {
        self.stationList = res.data
      })
    },


    handleStation(record) {
      let self = this
      self.fetchStationList()
      self.stationQuery.saiqu = record.id;
      self.stationVisible = true
    },


    // 增改 处理
    handleStationOk(e) {
      let self = this;

      e.preventDefault()
      this.form5.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.stationFormData)
          self.saveLoading = true;
          if (self.stationFormData.id > 0) {
            editStation({
              id: self.stationFormData.id,
              name: values.name,
              address: values.address,
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchStationList();

              self.stationFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          } else {
            addStation({
              saiqu: self.stationQuery.saiqu,
              name: values.name,
              address: values.address,
            }).then(res => {
              self.$message.success('新增成功')
              self.fetchStationList();

              self.stationFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },


    //执行官
    onAddZhixingguan() {
      this.zhixingguanFormData = {
        id: 0,
        name: '',
        show: 1,
      },
          this.form6.resetFields();
      this.zhixingguanFormVisible = true
      console.log('zhixingguanFormVisible');
    },

    handleZhixingguanCancel() {
      this.zhixingguanFormVisible = false
    },
    onEditZhixingguan(record) {
      let self = this
      this.zhixingguanFormVisible = true
      getZhixingguanDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form5.setFieldsValue({...res.data})
          self.zhixingguanFormData.id = record.id;
          self.zhixingguanFormData = {...res.data};
        }, 200)
      })
    },
    deleteZhixingguan(record) {
      let self = this;
      zhixingguanDelete({id: record.id}).then(res => {
        self.fetchZhixingguanList();
      })
    },

    fetchZhixingguanList() {
      let self = this
      getZhixingguanList(self.zhixingguanQuery).then(res => {
        self.zhixingguanList = res.data
      })
    },


    handleZhixingguan(record) {
      let self = this
      self.fetchZhixingguanList()
      self.zhixingguanQuery.saiqu = record.id;
      self.zhixingguanVisible = true
    },


    // 增改 处理
    handleZhixingguanOk(e) {
      let self = this;

      e.preventDefault()
      this.form6.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.zhixingguanFormData)
          self.saveLoading = true;
          if (self.zhixingguanFormData.id > 0) {
            editZhixingguan({
              id: self.zhixingguanFormData.id,
              name: values.name,
              num: values.num,
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchZhixingguanList();

              self.zhixingguanFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          } else {
            addZhixingguan({
              saiqu: self.zhixingguanQuery.saiqu,
              name: values.name,
              num: values.num,
            }).then(res => {
              self.$message.success('新增成功')
              self.fetchZhixingguanList();

              self.zhixingguanFormVisible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },

    download() {
      getDownloadUrl(this.queryParam).then(res => {
        console.log(res);
        window.open(res.data);
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

  },
  filters: {},
  watch: {}
}
</script>
